import { DoneActorEvent, ErrorActorEvent } from 'xstate';

import { saveReadingByReadingIdOutput, saveReadingOutput } from './MeterReadingsFlow.actors';

export enum GetReadingErrorCode {
  NO_CUSTOMER_ID = 'DCX-DW|583927ba-36e6-4180-ab01-c4b2c2dde475',
  NO_CONNECTIONS = 'DCX-DW|2e896b94-ddb7-48e1-a9ab-ea0f67f409c8',
  NO_READING_ID = 'DCX-DW|9cc7cd95-f98e-407f-beed-3cafcb4708d3',
  READING_ID_UKNOWN = 'DCX-DW|c959fbae-44dc-4be9-99a7-0f57f095c15d',
  INVALID_COMBINATION = 'DCX-DW|d2de46fc-2e1c-4469-abea-186db36331b9',
  DATA_ALREADY_SET = 'DCX-DW|0e60d9fd-1ac6-4d28-9084-a998b5e1c297',
  MVS_ERROR_YEARNOTE = 'DCX-DW|625bcb9d-bfb6-4958-a3c8-409294652763',
  MVS_ERROR_SWITCH = 'DCX-DW|87dce57b-da56-4041-bf83-278a2fd6cd83',
  MVS_ERROR_ENDNOTE = 'DCX-DW|fe73e888-cf49-4f5e-8446-7100caca213d',
  COMBINATION_EXPIRED = 'DCX-DW|a70026a4-42c4-4aa6-8e16-7f6bfb0163be',
  NOT_FOUND = 'DCX-DW|f37dd00e-2b50-45a8-b5ce-364d7063323d',
  SOMETHING_ELSE = 'DCX-DW|17379f5e-3089-4300-a616-15e49db95797',
}

export enum SaveReadingErrorCode {
  MVS_SAVE_ERROR_YEARNOTE = 'DCX-DW|625bcb9d-bfb6-4958-a3c8-409294652763',
  MVS_SAVE_ERROR_SWITCH = 'DCX-DW|87dce57b-da56-4041-bf83-278a2fd6cd83',
  MVS_SAVE_ERROR_ENDNOTE = 'DCX-DW|fe73e888-cf49-4f5e-8446-7100caca213d',
  MVS_YEARNOTE_NOT_AVAILABLE = 'DCX-DW|c35916be-e0ff-4439-9d77-ee3a83ea82fc',
}

export const errorTypes = {
  ...GetReadingErrorCode,
  ...SaveReadingErrorCode,
  NOT_SAVEABLE_METER: 'Not saveable',
  UNKNOWN: 'Unknown',
};

type SuccessInputParameter = { event: DoneActorEvent<saveReadingOutput | saveReadingByReadingIdOutput> };
type ErrorInputParameter = { event: ErrorActorEvent };

export const saveReadingConfirmationTargets = [
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.Adhoc',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'Adhoc',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.TariffMigration',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'TariffMigration',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.CloseDown',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'CloseDown',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicDelayed',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'PeriodicDelayed',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicEven',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'PeriodicEven',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicNewTermAmount',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'PeriodicNewTermAmount',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicPayBack',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'PeriodicPayBack',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicPayBackMore',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'PeriodicPayBackMore',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicPayBackLess',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'PeriodicPayBackLess',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicPayBackTermAmount',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'PeriodicPayBackTermAmount',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicGetBackTermAmount',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'PeriodicGetBackTermAmount',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicGetBack',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'PeriodicGetBack',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicDelayed',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'PeriodicDelayed',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.Registration',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'Registration',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.RelocationNewAddress',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'RelocationNewAddress',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.RelocationOldAddress',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'RelocationOldAddress',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.EnergyReport',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
    guard: ({ event }: SuccessInputParameter) => event.output?.resultType === 'EnergyReport',
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.Unknown',
    actions: { type: 'SET_SAVE_RESPONSE', params: ({ event }: SuccessInputParameter) => event.output },
  },
] as const;

export const saveReadingErrorTargets = [
  {
    target: '#METER_READINGS_FLOW.CONFIRMATION.ERROR_YEARNOTE',
    guard: {
      type: 'IS_EXPECTED_SAVE_READING_ERROR',
      params: ({ event }: ErrorInputParameter) => ({
        expectedErrorCode: SaveReadingErrorCode.MVS_SAVE_ERROR_YEARNOTE,
        actualError: event.error,
      }),
    },
  },
  {
    target: '#METER_READINGS_FLOW.CONFIRMATION.ERROR_SWITCH',
    guard: {
      type: 'IS_EXPECTED_SAVE_READING_ERROR',
      params: ({ event }: ErrorInputParameter) => ({
        expectedErrorCode: SaveReadingErrorCode.MVS_SAVE_ERROR_SWITCH,
        actualError: event.error,
      }),
    },
  },
  {
    target: '#METER_READINGS_FLOW.CONFIRMATION.ERROR_ENDNOTE',
    guard: {
      type: 'IS_EXPECTED_SAVE_READING_ERROR',
      params: ({ event }: ErrorInputParameter) => ({
        expectedErrorCode: SaveReadingErrorCode.MVS_SAVE_ERROR_ENDNOTE,
        actualError: event.error,
      }),
    },
  },
  {
    target: '#METER_READINGS_FLOW.CONFIRMATION.ERROR_NETWORK',
    guard: { type: 'IS_NETWORK_ERROR', params: ({ event }: ErrorInputParameter) => ({ error: event.error }) },
  },
  {
    target: '#METER_READINGS_FLOW.THANK_YOU.PeriodicDelayed',
    guard: {
      type: 'IS_EXPECTED_SAVE_READING_ERROR',
      params: ({ event }: ErrorInputParameter) => ({
        expectedErrorCode: SaveReadingErrorCode.MVS_YEARNOTE_NOT_AVAILABLE,
        actualError: event.error,
      }),
    },
  },
  {
    target: '#METER_READINGS_FLOW.CONFIRMATION.ERROR_UNKNOWN',
  },
] as const;
